import StoredLayout from '../../layouts/StoredLayout'
import Pagination from './Pagination'
export default StoredLayout(Pagination)



// WEBPACK FOOTER //
// ./src/ui-elements/pagination/index.js